import * as React from 'react';
import MarginOfSafetyModal from './MarginOfSafetyModal';

function ValueCalculator({data} :any) {

  return (
    <div className="col-lg-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">what is a good price to pay for <strong>{data.company_name}</strong> stock?</h4>
          <p>
            < MarginOfSafetyModal message="Calculate its margin-of-safety price." />
          </p>
          <form className="forms-sample" action={ "/ticker/" + data.ticker + "/valuation" } method="get">
            <div className="form-group">
              <label>Growth rate</label>
              <input type="number" className="form-control" step="0.01" name="growth_rate" defaultValue={data.estimated_valuation?.valuation?.eps_growth_rate} />
            </div>
            <div className="form-group">
              <label>Current EPS</label>
              <input type="number" className="form-control" step="0.01" name="current_eps" defaultValue={data.estimated_valuation?.valuation?.current_eps} />
            </div>
            <div className="form-group">
              <label>Future PE</label>
              <input type="number" className="form-control" step="0.01" name="future_pe" defaultValue={data.estimated_valuation?.valuation?.future_pe} />
            </div>
            <button type="submit" className="btn btn-gradient-primary mr-2">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ValueCalculator;
